var React = require('react');

function HamburgerIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.143,69.643H57.857A2.143,2.143,0,0,0,60,67.5V62.143A2.143,2.143,0,0,0,57.857,60H2.143A2.143,2.143,0,0,0,0,62.143V67.5A2.143,2.143,0,0,0,2.143,69.643Zm0,21.429H57.857A2.143,2.143,0,0,0,60,88.929V83.571a2.143,2.143,0,0,0-2.143-2.143H2.143A2.143,2.143,0,0,0,0,83.571v5.357A2.143,2.143,0,0,0,2.143,91.071Zm0,21.429H57.857A2.143,2.143,0,0,0,60,110.357V105a2.143,2.143,0,0,0-2.143-2.143H2.143A2.143,2.143,0,0,0,0,105v5.357A2.143,2.143,0,0,0,2.143,112.5Z","transform":"translate(0 -60)","fill":"#fff"}));
}

HamburgerIcon.defaultProps = {"width":"60","height":"52.5","viewBox":"0 0 60 52.5"};

module.exports = HamburgerIcon;

HamburgerIcon.default = HamburgerIcon;
